import type { App as VueApp } from 'vue';
import SplunkOtelWeb from '@splunk/otel-web';
import { createApp } from 'vue';
import { echoService } from '@/app/core/services/echo.service';
import { store } from './app/store';
import router from './app/router';
import { i18n } from './i18n';
import { registerInterceptors, setupApp } from '@/app/core/setupApp';
import { runAppInitializers } from '@/app/initializers/appInitializers';
import { apiClient } from '@/app/core/services/apiClient.service';
import { afterEachRoute, beforeEachRoute } from '@/app/router/hooks';
import App from './app/App.vue';
import { setStorageBaseUrl, setFlagsBasePath } from '@fifa-bsm/bo-frontend-shared/utils';
import { FLAGS_PATH, STORAGE_URL } from '@/app/core/common/config';
import { SPLUNK_REALM, SPLUNK_TOKEN, SPLUNK_APP_NAME, SPLUNK_ENV } from '@/app/core/common/config';

const splunkConfig = {
    realm: SPLUNK_REALM,
    rumAccessToken: SPLUNK_TOKEN,
    applicationName: SPLUNK_APP_NAME,
    deploymentEnvironment: SPLUNK_ENV,
};

try {
    SplunkOtelWeb.init(splunkConfig);
} catch {
    // eslint-disable-next-line no-console
    console.error('SplunkOtelWeb init failed');
}

// TODO: remove global components

if (import.meta.env.DEV) {
    const { createWorker } = await import('./api-mocks/setupInBrowser');
    const worker = await createWorker();
    worker.start({ onUnhandledRequest: 'bypass' });
}

let Application: VueApp<Element> | null = null;

setStorageBaseUrl(STORAGE_URL);
setFlagsBasePath(FLAGS_PATH);

registerInterceptors(apiClient, {
    toastService: () => Application?.config.globalProperties.$toasted,
});

router.beforeEach(beforeEachRoute(store));
router.afterEach(afterEachRoute(store));

runAppInitializers({ store, apiService: apiClient, echoService }).then(() => {
    Application = createApp(App)
        .use(i18n as any)
        .use(router)
        .use(store);

    setupApp({ app: Application });
    (router as any).app = Application;
    Application.mount('#app');
});
